(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["labor-day-timed-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.getElementById('dio-labor-day-bar');
    if (!bar) return;

    const startsAt = Date.parse(bar.dataset.start);
    const endsAt = Date.parse(bar.dataset.end);
    const designMode = bar.dataset.designMode === 'true';
    const previewMode = new URLSearchParams(window.location.search).get('preview_labor_day_bar') === '1';

    const promotionIsActive = () => {
      const now = Date.now();
      return designMode || previewMode || (now >= startsAt && now < endsAt);
    };

    const updateBar = () => {
      const active = promotionIsActive();
      bar.hidden = !active;
      bar.setAttribute('aria-hidden', String(!active));
    };

    updateBar();

    const nextChange = Date.now() < startsAt ? startsAt : endsAt;
    const delay = nextChange - Date.now();
    if (delay > 0 && delay <= 2147483647) {
      window.setTimeout(updateBar, delay + 1000);
    }

    if (window.__dioLaborDayGiftSyncInstalled) return;
    window.__dioLaborDayGiftSyncInstalled = true;

    const GIFT_VARIANT_ID = 44402244124931;
    const QUALIFYING_SPEND_CENTS = 7500;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const nativeFetch = window.fetch.bind(window);
    let syncing = false;

    const isGiftVariant = (item) => Number(item.variant_id) === GIFT_VARIANT_ID;
    const isManagedGift = (item) => {
      return isGiftVariant(item) &&
        item.properties &&
        item.properties._dio_labor_day_gift === 'Labor Day 2026';
    };
    const hasFullGiftDiscount = (item) => {
      if (!isGiftVariant(item)) return false;
      if (Number(item.final_line_price) === 0) return true;

      const allocations = item.line_level_discount_allocations || [];
      const allocatedCents = allocations.reduce((total, allocation) => {
        return total + Number(allocation.amount || 0);
      }, 0);

      return allocatedCents >= Number(item.original_price || 0);
    };
    const refreshCartSections = () => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    };
    const fetchCart = async () => {
      const response = await nativeFetch(root + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    };
    const removeManagedGift = async (item) => {
      const response = await nativeFetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });

      if (!response.ok) throw new Error('Unable to remove promotional gift');
      await response.json();
      refreshCartSections();
    };
    const addManagedGift = async () => {
      const response = await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { _dio_labor_day_gift: 'Labor Day 2026' }
          }]
        })
      });

      if (!response.ok) throw new Error('Unable to add promotional gift');
      await response.json();
    };

    const syncGift = async () => {
      if (syncing) return;
      syncing = true;

      try {
        let cart = await fetchCart();
        const managedGift = cart.items.find(isManagedGift);
        const discountedGift = cart.items.find(hasFullGiftDiscount);

        const qualifyingSpend = cart.items.reduce((total, item) => {
          if (isManagedGift(item) || hasFullGiftDiscount(item)) return total;
          if (item.selling_plan_allocation) return total;
          return total + Number(item.original_line_price || 0);
        }, 0);

        const shouldHaveGift = promotionIsActive() && qualifyingSpend >= QUALIFYING_SPEND_CENTS;

        if (!shouldHaveGift) {
          if (managedGift) await removeManagedGift(managedGift);
          return;
        }

        if (discountedGift) return;

        if (!managedGift) {
          await addManagedGift();
          cart = await fetchCart();
        }

        const verifiedGift = cart.items.find(isManagedGift);
        if (verifiedGift && hasFullGiftDiscount(verifiedGift)) {
          refreshCartSections();
        } else if (verifiedGift) {
          await removeManagedGift(verifiedGift);
        }
      } catch (error) {
        console.warn('Labor Day gift sync:', error);
      } finally {
        syncing = false;
      }
    };

    window.fetch = async (...args) => {
      const response = await nativeFetch(...args);

      try {
        const input = args[0];
        const rawUrl = typeof input === 'string' ? input : input && input.url;
        const path = new URL(rawUrl || '', window.location.href).pathname;

        if (!syncing && /\/cart\/(add|change|update|clear)\.js$/.test(path)) {
          window.setTimeout(syncGift, 100);
        }
      } catch (error) {
        console.warn('Labor Day gift watcher:', error);
      }

      return response;
    };

    window.setTimeout(syncGift, 0);
    window.addEventListener('pageshow', syncGift);
  })();
  } catch(e) { console.error(e); }
})();

})();
